
export const configuracion = { 
    base_url: 'https://servidor-mario.top-secret.mx'
    //base_url: 'http://localhost:5000'
};